module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-2-2af0a5160d68754e785f8f1b5b06c5da.png";